import deepCamelizeKeys from '../../../../utils/object/deepCamelizeKeys.js'
import { API_HOST_NAME } from '../constants.js'

const URL = `${API_HOST_NAME}/api/v1/auth/refresh`

const useRefreshToken = () => {
  const refresh = (refreshToken) => {
    return fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        refresh: {
          refresh_token: refreshToken,
        },
      }),
    })
      .then((response) => {
        if (!response.ok) {
          const error = new Error(`Refresh failed: ${response.status}`)
          error.status = response.status
          return Promise.reject(error)
        }
        return response.json()
      })
      .then(({ token }) => ({ token: deepCamelizeKeys(token) }))
  }

  return { refresh }
}

export default useRefreshToken
